import React from "react";
import Abtusimg from "../images/abtusimage.jpeg";

export default function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <h2>About NARMADA SOLAR SOLUTIONS</h2>
          <p className="section-subtitle">
            Leading solar installation company in Cuttack, Odisha
          </p>
        </div>
        <div className="about-content">
          <div className="about-text">
            <p>
              We are a leading solar installation company specializing in both
              residential and industrial solar systems. Our expertise covers both
              off-grid and on-grid solar solutions, ensuring energy independence
              and sustainability for our clients.
            </p>
            <p>
              We pride ourselves on using the best quality solar panels and
              batteries while maintaining minimal costs and providing exceptional
              onsite services.
            </p>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🌟</div>
                <h4>Best Quality Equipments</h4>
                <p>
                  We use premium solar panels and components for maximum
                  efficiency and durability
                </p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">💰</div>
                <h4>Minimal Cost</h4>
                <p>Competitive pricing without compromising on quality</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔧</div>
                <h4>Expert Installation</h4>
                <p>
                  Professional installation by certified technicians with years
                  of experience
                </p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <h4>Energy Independence</h4>
                <p>Complete solar solutions for sustainable energy</p>
              </div>
            </div>
          </div>
          <div className="about-image">
            <img
              src={Abtusimg}
              alt="Professional Solar Installation"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
